import React, {FC} from 'react'
import {Trans, useTranslation} from 'react-i18next'
import {useHistory} from 'react-router'
import {Redirect} from 'react-router-dom'

import {Box, Typography} from '@mui/material'
import Dinero from 'dinero.js'
import {makeStyles} from 'tss-react/mui'

import {ReactComponent as AspiringMemberIllu} from '@progyny/assets/images/aspiring-member-illu.svg'
import SubmitButton from '@progyny/components/Buttons/SubmitButton'
import PageLoader from '@progyny/components/PageLoader'
import useLocalizedDate from '@progyny/hooks/useLocalizedDate'
import {RouteEnum, useRoutes} from '@progyny/routes'
import {useMeStore} from '@progyny/store/meStore'
import {hideZeroCents} from '@progyny/utils/dinero'

const useStyles = makeStyles()(() => ({
  container: {
    maxWidth: 430,
  },
  companyName: {
    textTransform: 'capitalize',
  },
}))

const MemberAspiring: FC = () => {
  const {t} = useTranslation()
  const user = useMeStore((s) => s.user)
  const setMyLocale = useMeStore((s) => s.setMyLocale)
  const loading = useMeStore((s) => s.loading)
  const {classes} = useStyles()
  const history = useHistory()
  const eligibilityStartDate = useLocalizedDate(user?.member?.eligibilityStart)
  const {getPath} = useRoutes()

  const companyName = user?.company?.name
  const employedFor = user?.member?.contract?.aspiringPeriodDescription

  if (!user?.member?.isAspiring) {
    return <Redirect to={getPath(RouteEnum.HOME)} />
  }
  const companyBudget = hideZeroCents(
    setMyLocale(
      Dinero(user?.member?.contract?.budgetPerMember as Dinero.Options)
    )
  )

  if (loading || !user) {
    return <PageLoader position={'center'} loadingMessage={'test'} />
  }

  return (
    <Box
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      className={classes.container}
      flexDirection={'column'}
      mt={14}
      mx={'auto'}
    >
      <Box mb={6}>
        <AspiringMemberIllu />
      </Box>
      <Box>
        <Box mb={3}>
          <Typography variant={'h3'} fontWeight={600}>
            <Trans i18nKey='home_member_aspiring_you_are_now_aspiring_member' />
          </Typography>
        </Box>
        <Box mb={5}>
          <Typography variant={'body1'}>
            {t('home_member_aspiring_as_strong_aspiring_member_strong', {
              companyName,
              employedFor,
              eligibilityStartDate,
              companyBudget,
            })}
          </Typography>
        </Box>
        <Box
          textAlign={'center'}
          onClick={() => history.push(getPath(RouteEnum.HOME))}
        >
          <SubmitButton>
            {t('home_member_aspiring_start_exploring')}
          </SubmitButton>
        </Box>
      </Box>
    </Box>
  )
}

export default MemberAspiring
